var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCore(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\u56FE\\u5C42_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: 0,
    y: 0,
    viewBox: "0 0 122 122",
    style: {
      enableBackground: "new 0 0 122 122"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M61.1 13c1.1 0 2.1.3 3 .8L101 35.1c1.9 1.1 3 3.1 3 5.2v41.4c0 2.1-1.1 4.1-3 5.2l-36.9 21.3c-.9.5-1.9.8-3 .8s-2.1-.3-3-.8l-37-21.3c-1.9-1.1-3-3.1-3-5.2V40.3c0-2.1 1.1-4.1 3-5.2L58 13.8c1-.5 2-.8 3.1-.8m0-12c-3.1 0-6.2.8-9 2.4l-37 21.3c-5.6 3.2-9 9.2-9 15.6v41.4c0 6.4 3.4 12.4 9 15.6L52 118.6c2.8 1.6 5.9 2.4 9 2.4s6.2-.8 9-2.4l36.9-21.3c5.6-3.2 9-9.2 9-15.6V40.3c0-6.4-3.4-12.4-9-15.6L70.1 3.4c-2.8-1.6-5.9-2.4-9-2.4z",
    style: {
      fill: "#ff9500"
    }
  }));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCore);
export default __webpack_public_path__ + "static/media/core.4d1e9a2ae466e413d517e44b2bcb71e1.svg";
export { ForwardRef as ReactComponent };